<template>
    <index-table
        :cols="[
            {
                value: 'serial_number',
                label: 'Serial Number',
                sortable: true,
                searchable: true,
            },
        ]"
        :title="'Device Whitelist'"
        :model="'device-whitelist'"
        :createText="'Append to Whitelist'"
        :options="['deletable']"
        data-test-id="device-whitelist-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },
}
</script>
